import dayjs from "dayjs";

export const getShortMonthName = (monthNumber) => dayjs(monthNumber, { format: 'MM' }).format('MMM');